import ApiService from 'config/apiServiceApiGateway'

export type GetVendorsRequestParamsType = {
  source_type?: string
  company_name?: string
}

export type VendorItemType = {
  id: number
  company_name: string
}

export type GetVendorsResponseType = {
  data: VendorItemType[]
}

export const getVendorsApi = (params: GetVendorsRequestParamsType) =>
  ApiService.Get<GetVendorsResponseType, true>({
    url: '/commercial/internal/v1/vendors',
    params,
  })
